// redux/modal-slice/modalSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

const initialState = {
  isMainModalOpen: false,
  isSubModalOpen: false,
  shouldCloseAllOnConfirm: false
};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openMainModal(state) {
      state.isMainModalOpen = true;
    },
    closeMainModal(state) {
      state.isMainModalOpen = false;
    },
    openSubModal(state, action) {
      state.isSubModalOpen = true;
      state.shouldCloseAllOnConfirm = action.payload?.closeAll || false;
    },
    closeSubModal(state) {
      state.isSubModalOpen = false;
    },
    closeAllModals(state) {
      state.isMainModalOpen = false;
      state.isSubModalOpen = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

export const selectIsMainModalOpen = (state) => state.modal.isMainModalOpen;
export const selectIsSubModalOpen = (state) => state.modal.isSubModalOpen;
export const selectShouldCloseAllOnConfirm = (state) => state.modal.shouldCloseAllOnConfirm;
